<template>
  <div v-loading="isLoading" class="p-3 bg-white h-full">
    <div class="d-flex align-items-center border-bottom pb-2 mb-4">
      <a href="javascript:;" class="fs-18 txt-grey-900" @click="backToMdtDetail">
        {{ room ? room.name : "" }}
        <!-- <span class="spinner-border" role="status" v-if="!room">
          <span class="sr-only">Loading...</span>
        </span>-->
      </a>
      <div v-if="session">
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="mx-2"
        >
          <path
            d="M8.29492 17.09L12.8749 12.5L8.29492 7.91L9.70492 6.5L15.7049 12.5L9.70492 18.5L8.29492 17.09Z"
            fill="#667085"
          />
        </svg>
        <a href="javascript:;" class="fs-18 txt-grey-900 mr-2">
          {{ $t("multidisciplinary_board.lbl_date") }}
          {{ formatDate(session.date) }} ({{
          (session.mdt_room_diseases && session.mdt_room_diseases.length) ||
          0
          }})
        </a>
        <button
          :disabled="!room"
          class="btn bg-pri text-white fs-14 fw-600"
          :class="!room ? 'pointer-events-none' : ''"
          type="button"
          @click="goToRoom(room)"
        >
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-2"
          >
            <path
              d="M9.16699 6.33333L8.00033 7.5L10.167 9.66667H1.66699V11.3333H10.167L8.00033 13.5L9.16699 14.6667L13.3337 10.5L9.16699 6.33333ZM16.667 16.3333H10.0003V18H16.667C17.5837 18 18.3337 17.25 18.3337 16.3333V4.66667C18.3337 3.75 17.5837 3 16.667 3H10.0003V4.66667H16.667V16.3333Z"
              fill="white"
            />
          </svg>
          {{ $t("multidisciplinary_board.btn_join_room") }}
        </button>
      </div>
    </div>
    <div class="flex justify-between items-start lg:items-center gap-2 flex-col lg:flex-row">
      <div style="width:300px">
        <div class="input-group radius-12 border">
          <div class="input-group-text bg-white radius-12 border-0">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.7104 20.2894L18.0004 16.6094C19.4405 14.8138 20.1379 12.5347 19.9492 10.2407C19.7605 7.94672 18.7001 5.8122 16.9859 4.27606C15.2718 2.73992 13.0342 1.91893 10.7333 1.98189C8.43243 2.04485 6.24311 2.98698 4.61553 4.61456C2.98795 6.24214 2.04582 8.43145 1.98286 10.7323C1.9199 13.0332 2.7409 15.2708 4.27704 16.9849C5.81318 18.6991 7.94769 19.7595 10.2417 19.9482C12.5357 20.1369 14.8148 19.4395 16.6104 17.9994L20.2904 21.6794C20.3834 21.7731 20.494 21.8475 20.6158 21.8983C20.7377 21.9491 20.8684 21.9752 21.0004 21.9752C21.1324 21.9752 21.2631 21.9491 21.385 21.8983C21.5068 21.8475 21.6174 21.7731 21.7104 21.6794C21.8906 21.493 21.9914 21.2438 21.9914 20.9844C21.9914 20.7251 21.8906 20.4759 21.7104 20.2894ZM11.0004 17.9994C9.61592 17.9994 8.26255 17.5889 7.1114 16.8197C5.96026 16.0505 5.06305 14.9573 4.53324 13.6782C4.00342 12.3991 3.8648 10.9917 4.1349 9.63378C4.40499 8.27592 5.07168 7.02864 6.05065 6.04967C7.02961 5.0707 8.27689 4.40402 9.63476 4.13392C10.9926 3.86382 12.4001 4.00245 13.6792 4.53226C14.9583 5.06207 16.0515 5.95928 16.8207 7.11042C17.5899 8.26157 18.0004 9.61495 18.0004 10.9994C18.0004 12.8559 17.2629 14.6364 15.9501 15.9492C14.6374 17.2619 12.8569 17.9994 11.0004 17.9994Z"
                fill="#475467"
              />
            </svg>
          </div>
          <input type="text" class="form-control bg-white radius-12" v-model="search" />
        </div>
      </div>
      <div class="flex">
        <div class="flex gap-2 flex-col lg:flex-row">
          <div class="flex-auto">
            <button
              type="button"
              class="btn bg-pri-50 border bd-pri w-100 h-100"
              @click="createMdtDisease"
            >
              <span class="txt-pri fs-14 fw-600">+ {{ $t("multidisciplinary_board.btn_add_case") }}</span>
            </button>
          </div>
          <div class="flex-auto">
            <!-- <button
              type="button"
              class="btn bg-pri text-white border bd-pri w-100 h-100"
              @click="processPPT"
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.00156 9.93635L7.16227 10.7819V7.14603C7.16227 6.97352 7.09372 6.80809 6.97171 6.68611C6.84969 6.56413 6.68421 6.4956 6.51165 6.4956C6.3391 6.4956 6.17361 6.56413 6.0516 6.68611C5.92958 6.80809 5.86104 6.97352 5.86104 7.14603V10.7819L5.02174 9.93635C4.96108 9.8757 4.88906 9.8276 4.8098 9.79478C4.73054 9.76196 4.64559 9.74506 4.5598 9.74506C4.47401 9.74506 4.38906 9.76196 4.3098 9.79478C4.23054 9.8276 4.15853 9.8757 4.09787 9.93635C4.0372 9.99699 3.98908 10.069 3.95625 10.1482C3.92342 10.2275 3.90652 10.3124 3.90652 10.3982C3.90652 10.4839 3.92342 10.5688 3.95625 10.6481C3.98908 10.7273 4.0372 10.7993 4.09787 10.86L6.04972 12.8112C6.11159 12.8704 6.18455 12.9169 6.26442 12.9478C6.3423 12.9822 6.42651 13 6.51165 13C6.5968 13 6.68101 12.9822 6.75889 12.9478C6.83875 12.9169 6.91171 12.8704 6.97359 12.8112L8.92544 10.86C9.04795 10.7375 9.11678 10.5714 9.11678 10.3982C9.11678 10.2249 9.04795 10.0588 8.92544 9.93635C8.80293 9.81387 8.63676 9.74506 8.4635 9.74506C8.29024 9.74506 8.12408 9.81387 8.00156 9.93635ZM10.6886 2.73615C10.2911 1.82296 9.605 1.06526 8.73551 0.579163C7.86601 0.0930679 6.86107 -0.0946084 5.87468 0.0448928C4.88828 0.184394 3.97485 0.643377 3.27435 1.35151C2.57385 2.05964 2.12493 2.97786 1.99637 3.96545C1.37607 4.11396 0.831915 4.48503 0.467255 5.0082C0.102595 5.53138 -0.0571766 6.17021 0.0182816 6.80339C0.0937398 7.43657 0.399173 8.02 0.876577 8.44288C1.35398 8.86576 1.97011 9.09864 2.60795 9.0973C2.78051 9.0973 2.94599 9.02877 3.06801 8.9068C3.19002 8.78482 3.25857 8.61938 3.25857 8.44688C3.25857 8.27437 3.19002 8.10894 3.06801 7.98696C2.94599 7.86498 2.78051 7.79645 2.60795 7.79645C2.26285 7.79645 1.93187 7.6594 1.68784 7.41544C1.44381 7.17149 1.30672 6.84061 1.30672 6.4956C1.30672 6.1506 1.44381 5.81972 1.68784 5.57576C1.93187 5.33181 2.26285 5.19475 2.60795 5.19475C2.78051 5.19475 2.94599 5.12623 3.06801 5.00425C3.19002 4.88227 3.25857 4.71683 3.25857 4.54433C3.26023 3.77506 3.53462 3.03128 4.03298 2.44514C4.53134 1.85899 5.22141 1.46844 5.98059 1.34286C6.73976 1.21727 7.51889 1.3648 8.17955 1.75922C8.84021 2.15364 9.33963 2.76941 9.58907 3.49714C9.62626 3.60891 9.69311 3.70849 9.78249 3.78524C9.87187 3.86199 9.98042 3.91304 10.0965 3.93293C10.5299 4.0148 10.9227 4.24097 11.2111 4.5746C11.4994 4.90822 11.6662 5.32962 11.6843 5.77015C11.7024 6.21067 11.5708 6.64433 11.3108 7.00048C11.0508 7.35663 10.6779 7.61427 10.2527 7.73141C10.1698 7.75276 10.092 7.79023 10.0236 7.84166C9.95517 7.8931 9.89758 7.95749 9.85408 8.03118C9.81059 8.10486 9.78203 8.18639 9.77005 8.27111C9.75807 8.35583 9.76289 8.44207 9.78425 8.52493C9.80561 8.60778 9.84309 8.68562 9.89454 8.75399C9.94599 8.82236 10.0104 8.87994 10.0841 8.92342C10.1578 8.96691 10.2394 8.99546 10.3241 9.00743C10.4089 9.01941 10.4951 9.01459 10.578 8.99323C11.2627 8.81236 11.8697 8.41305 12.3067 7.85594C12.7437 7.29884 12.987 6.61438 12.9995 5.90649C13.012 5.19861 12.7931 4.50598 12.376 3.93379C11.959 3.3616 11.3665 2.9411 10.6886 2.73615Z"
                  fill="white"
                />
              </svg>
              <span class="fs-14 fw-600">Xuất file</span>
            </button>-->

            <el-dropdown class="text-white h-100 w-100">
              <!-- <button class="el-dropdown-link btn bg-pri text-white border bd-pri fs-14 fw-600">
                <span>Xuất file</span><i class="el-icon-arrow-down el-icon--right ml-1 mt-2"></i>
              </button>-->
              <button
                type="button"
                class="el-dropdown-link btn bg-pri text-white border bd-pri w-100 h-100"
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00156 9.93635L7.16227 10.7819V7.14603C7.16227 6.97352 7.09372 6.80809 6.97171 6.68611C6.84969 6.56413 6.68421 6.4956 6.51165 6.4956C6.3391 6.4956 6.17361 6.56413 6.0516 6.68611C5.92958 6.80809 5.86104 6.97352 5.86104 7.14603V10.7819L5.02174 9.93635C4.96108 9.8757 4.88906 9.8276 4.8098 9.79478C4.73054 9.76196 4.64559 9.74506 4.5598 9.74506C4.47401 9.74506 4.38906 9.76196 4.3098 9.79478C4.23054 9.8276 4.15853 9.8757 4.09787 9.93635C4.0372 9.99699 3.98908 10.069 3.95625 10.1482C3.92342 10.2275 3.90652 10.3124 3.90652 10.3982C3.90652 10.4839 3.92342 10.5688 3.95625 10.6481C3.98908 10.7273 4.0372 10.7993 4.09787 10.86L6.04972 12.8112C6.11159 12.8704 6.18455 12.9169 6.26442 12.9478C6.3423 12.9822 6.42651 13 6.51165 13C6.5968 13 6.68101 12.9822 6.75889 12.9478C6.83875 12.9169 6.91171 12.8704 6.97359 12.8112L8.92544 10.86C9.04795 10.7375 9.11678 10.5714 9.11678 10.3982C9.11678 10.2249 9.04795 10.0588 8.92544 9.93635C8.80293 9.81387 8.63676 9.74506 8.4635 9.74506C8.29024 9.74506 8.12408 9.81387 8.00156 9.93635ZM10.6886 2.73615C10.2911 1.82296 9.605 1.06526 8.73551 0.579163C7.86601 0.0930679 6.86107 -0.0946084 5.87468 0.0448928C4.88828 0.184394 3.97485 0.643377 3.27435 1.35151C2.57385 2.05964 2.12493 2.97786 1.99637 3.96545C1.37607 4.11396 0.831915 4.48503 0.467255 5.0082C0.102595 5.53138 -0.0571766 6.17021 0.0182816 6.80339C0.0937398 7.43657 0.399173 8.02 0.876577 8.44288C1.35398 8.86576 1.97011 9.09864 2.60795 9.0973C2.78051 9.0973 2.94599 9.02877 3.06801 8.9068C3.19002 8.78482 3.25857 8.61938 3.25857 8.44688C3.25857 8.27437 3.19002 8.10894 3.06801 7.98696C2.94599 7.86498 2.78051 7.79645 2.60795 7.79645C2.26285 7.79645 1.93187 7.6594 1.68784 7.41544C1.44381 7.17149 1.30672 6.84061 1.30672 6.4956C1.30672 6.1506 1.44381 5.81972 1.68784 5.57576C1.93187 5.33181 2.26285 5.19475 2.60795 5.19475C2.78051 5.19475 2.94599 5.12623 3.06801 5.00425C3.19002 4.88227 3.25857 4.71683 3.25857 4.54433C3.26023 3.77506 3.53462 3.03128 4.03298 2.44514C4.53134 1.85899 5.22141 1.46844 5.98059 1.34286C6.73976 1.21727 7.51889 1.3648 8.17955 1.75922C8.84021 2.15364 9.33963 2.76941 9.58907 3.49714C9.62626 3.60891 9.69311 3.70849 9.78249 3.78524C9.87187 3.86199 9.98042 3.91304 10.0965 3.93293C10.5299 4.0148 10.9227 4.24097 11.2111 4.5746C11.4994 4.90822 11.6662 5.32962 11.6843 5.77015C11.7024 6.21067 11.5708 6.64433 11.3108 7.00048C11.0508 7.35663 10.6779 7.61427 10.2527 7.73141C10.1698 7.75276 10.092 7.79023 10.0236 7.84166C9.95517 7.8931 9.89758 7.95749 9.85408 8.03118C9.81059 8.10486 9.78203 8.18639 9.77005 8.27111C9.75807 8.35583 9.76289 8.44207 9.78425 8.52493C9.80561 8.60778 9.84309 8.68562 9.89454 8.75399C9.94599 8.82236 10.0104 8.87994 10.0841 8.92342C10.1578 8.96691 10.2394 8.99546 10.3241 9.00743C10.4089 9.01941 10.4951 9.01459 10.578 8.99323C11.2627 8.81236 11.8697 8.41305 12.3067 7.85594C12.7437 7.29884 12.987 6.61438 12.9995 5.90649C13.012 5.19861 12.7931 4.50598 12.376 3.93379C11.959 3.3616 11.3665 2.9411 10.6886 2.73615Z"
                    fill="white"
                  />
                </svg>
                <span class="fs-14 fw-600">
                  {{
                  $t("multidisciplinary_board.btn_export_file")
                  }}
                </span>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div @click="processPPT">{{ $t("multidisciplinary_board.lbl_all_case") }}</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="processTQM">{{ $t("multidisciplinary_board.lbl_all_case_surgery") }}</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="processHC">{{ $t("multidisciplinary_board.lbl_all_case_mdt") }}</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="flex-auto">
            <button
              type="button"
              class="btn bg-pri text-white border bd-pri w-100 h-100"
              @click="showModalSend"
            >
              <div>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.4404 4.965C13.3643 4.78174 13.2187 4.63611 13.0354 4.56C12.9453 4.52157 12.8485 4.50118 12.7504 4.5H5.25044C5.05153 4.5 4.86076 4.57902 4.72011 4.71967C4.57946 4.86032 4.50044 5.05109 4.50044 5.25C4.50044 5.44891 4.57946 5.63968 4.72011 5.78033C4.86076 5.92098 5.05153 6 5.25044 6H10.9429L4.71794 12.2175C4.64765 12.2872 4.59185 12.3702 4.55377 12.4616C4.5157 12.553 4.49609 12.651 4.49609 12.75C4.49609 12.849 4.5157 12.947 4.55377 13.0384C4.59185 13.1298 4.64765 13.2128 4.71794 13.2825C4.78766 13.3528 4.87062 13.4086 4.96201 13.4467C5.0534 13.4847 5.15143 13.5043 5.25044 13.5043C5.34945 13.5043 5.44748 13.4847 5.53888 13.4467C5.63027 13.4086 5.71322 13.3528 5.78294 13.2825L12.0004 7.0575V12.75C12.0004 12.9489 12.0795 13.1397 12.2201 13.2803C12.3608 13.421 12.5515 13.5 12.7504 13.5C12.9494 13.5 13.1401 13.421 13.2808 13.2803C13.4214 13.1397 13.5004 12.9489 13.5004 12.75V5.25C13.4993 5.15199 13.4789 5.05517 13.4404 4.965Z"
                    fill="white"
                  />
                </svg>
              </div>
              <span class="fs-14 fw-600">
                {{
                $t("multidisciplinary_board.btn_submit_org")
                }}
              </span>
            </button>
          </div>
          <div class="col-2">
            <button type="button" class="btn bg-pri-50 border bd-pri h-100" @click="gotoPrint">
              <svg
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.8332 4.66667H13.9998V0.5H3.99984V4.66667H3.1665C1.78317 4.66667 0.666504 5.78333 0.666504 7.16667V12.1667H3.99984V15.5H13.9998V12.1667H17.3332V7.16667C17.3332 5.78333 16.2165 4.66667 14.8332 4.66667ZM5.6665 2.16667H12.3332V4.66667H5.6665V2.16667ZM12.3332 13.8333H5.6665V10.5H12.3332V13.8333ZM13.9998 10.5V8.83333H3.99984V10.5H2.33317V7.16667C2.33317 6.70833 2.70817 6.33333 3.1665 6.33333H14.8332C15.2915 6.33333 15.6665 6.70833 15.6665 7.16667V10.5H13.9998Z"
                  fill="#20419B"
                />
                <path
                  d="M13.9998 8.41667C14.4601 8.41667 14.8332 8.04357 14.8332 7.58333C14.8332 7.1231 14.4601 6.75 13.9998 6.75C13.5396 6.75 13.1665 7.1231 13.1665 7.58333C13.1665 8.04357 13.5396 8.41667 13.9998 8.41667Z"
                  fill="#20419B"
                />
              </svg>
              <span class="txt-pri fs-14 fw-600">
                {{
                $t("multidisciplinary_board.lbl_print")
                }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="table-responsive">
        <table class="table table-vcenter table-mobile-md card-table">
          <thead>
            <tr>
              <th width="10px"></th>
              <th>{{ $t("multidisciplinary_board.lbl_patient") }}</th>
              <th>{{ $t("multidisciplinary_board.lbl_diagnose") }}</th>
              <th>{{ $t("multidisciplinary_board.lbl_register_time") }}</th>
              <th>{{ $t("multidisciplinary_board.lbl_attending_doctor") }}</th>
              <th>{{ $t("multidisciplinary_board.lbl_hd_status") }}</th>
              <th>{{ $t("multidisciplinary_board.lbl_mdt_report") }}</th>
              <th>{{ $t("multidisciplinary_board.lbl_surgery_report") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="7" class="pt-4 cursor-pointer" @click="show_ts = !show_ts">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="mr-2"
                  :class="!show_ts ? 'upsidedown' : ''"
                >
                  <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="#1D2939" />
                </svg>
                <span class="fs-16 fw-600 mb-0 txt-grey-900">
                  {{
                  $t("multidisciplinary_board.lbl_type_surgery")
                  }}
                </span>
              </td>
            </tr>
          </tbody>
          <tbody v-if="session" v-show="show_ts">
            <tr
              v-for="d in tsDiseases"
              :key="d.id"
              @click="goToMdtDisease(d.id, $event)"
              class="cursor-pointer"
            >
              <td @click.stop>
                <input v-if="d.sendable" type="checkbox" v-model="d.selectedToSend" />
              </td>
              <td :data-label="$t('multidisciplinary_board.lbl_patient')">
                <p class="fs-14 fw-600 txt-grey-900 mb-0">{{ d.patient_name }}</p>
                <p class="fs-12 txt-grey-600 mb-0">
                  ({{ mdtUtils.getYearOrders(d.patient_birthday)
                  }}{{ d.patient_address ? " - " + d.patient_address : "" }})
                </p>
              </td>
              <td :data-label="$t('multidisciplinary_board.lbl_diagnose')">
                <!-- <p class="fs-14 fw-500 txt-grey-900 mb-0">{{ d.patient_diagnostic }}</p> -->
                <p class="fs-14 fw-500 txt-grey-900 mb-0">{{ patientDiagnostic(d) }}</p>
              </td>
              <td :data-label="$t('multidisciplinary_board.lbl_register_time')">
                <p class="fs-14 fw-500 txt-grey-700 mb-0">{{ formatDateDMYHm(d.created_at) }}</p>
              </td>
              <td :data-label="$t('multidisciplinary_board.lbl_attending_doctor')">
                <p
                  class="fs-14 whitespace-nowrap w-40 fw-500 txt-grey-700 mb-0"
                >{{ d.doctor && d.doctor.name }}</p>
              </td>
              <td
                :data-label="$t('multidisciplinary_board.lbl_hd_status')"
                :set="
                (sttClass = mdtUtils.getStatusDisease(
                  d.sended ? 3 : d.status
                ))
              "
              >
                <p class="fs-16 fw-500 mb-0" :class="sttClass.class">{{ sttClass.text }}</p>
              </td>
              <td @click.stop :data-label="$t('multidisciplinary_board.lbl_mdt_report')">
                <div class="d-flex" v-if="d.concluding">
                  <el-dropdown v-if="d.concluding.multilang">
                    <div>
                      <svg
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="mr-2 cursor-pointer"
                      >
                        <path
                          d="M16.4997 11.4167C19.658 11.4167 22.4747 13.1917 23.8497 16C22.4747 18.8083 19.6663 20.5833 16.4997 20.5833C13.333 20.5833 10.5247 18.8083 9.14967 16C10.5247 13.1917 13.3413 11.4167 16.4997 11.4167ZM16.4997 9.75C12.333 9.75 8.77467 12.3417 7.33301 16C8.77467 19.6583 12.333 22.25 16.4997 22.25C20.6663 22.25 24.2247 19.6583 25.6663 16C24.2247 12.3417 20.6663 9.75 16.4997 9.75ZM16.4997 13.9167C17.6497 13.9167 18.583 14.85 18.583 16C18.583 17.15 17.6497 18.0833 16.4997 18.0833C15.3497 18.0833 14.4163 17.15 14.4163 16C14.4163 14.85 15.3497 13.9167 16.4997 13.9167ZM16.4997 12.25C14.433 12.25 12.7497 13.9333 12.7497 16C12.7497 18.0667 14.433 19.75 16.4997 19.75C18.5663 19.75 20.2497 18.0667 20.2497 16C20.2497 13.9333 18.5663 12.25 16.4997 12.25Z"
                          fill="#20409B"
                        />
                        <rect
                          x="1.25"
                          y="0.75"
                          width="30.5"
                          height="30.5"
                          rx="7.25"
                          stroke="#20419B"
                          stroke-width="1.5"
                        />
                      </svg>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item, index) in d.concluding.multilang"
                        :key="index"
                        :disabled="
                        !item.file_name_printing
                      "
                      >
                        <div
                          @click="openUrl({ fileName: item.file_name_printing })"
                        >{{ $t(`common.${appUtils.getLangCode(Number(item.lang))}`) }}</div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <el-dropdown v-if="d.concluding.multilang && (d.status > 1)">
                    <div>
                      <svg
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="cursor-pointer"
                      >
                        <path
                          d="M22.3337 12.6667H21.5003V8.5H11.5003V12.6667H10.667C9.28366 12.6667 8.16699 13.7833 8.16699 15.1667V20.1667H11.5003V23.5H21.5003V20.1667H24.8337V15.1667C24.8337 13.7833 23.717 12.6667 22.3337 12.6667ZM13.167 10.1667H19.8337V12.6667H13.167V10.1667ZM19.8337 21.8333H13.167V18.5H19.8337V21.8333ZM21.5003 18.5V16.8333H11.5003V18.5H9.83366V15.1667C9.83366 14.7083 10.2087 14.3333 10.667 14.3333H22.3337C22.792 14.3333 23.167 14.7083 23.167 15.1667V18.5H21.5003Z"
                          fill="#20409B"
                        />
                        <path
                          d="M21.5003 16.4167C21.9606 16.4167 22.3337 16.0436 22.3337 15.5833C22.3337 15.1231 21.9606 14.75 21.5003 14.75C21.0401 14.75 20.667 15.1231 20.667 15.5833C20.667 16.0436 21.0401 16.4167 21.5003 16.4167Z"
                          fill="#20409B"
                        />
                        <rect
                          x="1.25"
                          y="0.75"
                          width="30.5"
                          height="30.5"
                          rx="7.25"
                          stroke="#20419B"
                          stroke-width="1.5"
                        />
                      </svg>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item, index) in d.concluding.multilang"
                        :key="index"
                        :disabled="
                        !item.file_name_printing
                      "
                      >
                        <div
                          @click="openUrl({ fileName: item.file_name_printing })"
                        >{{ $t(`common.${appUtils.getLangCode(Number(item.lang))}`) }}</div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </td>
              <td :data-label="$t('multidisciplinary_board.lbl_surgery_report')">
                <div
                  @click.stop
                  class="d-flex"
                  v-if="d.operation && d.operation.file_name_printing"
                >
                  <svg
                    width="33"
                    height="32"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="mr-2 cursor-pointer"
                    @click="openUrl({ fileName: d.operation.file_name_printing })"
                  >
                    <path
                      d="M16.4997 11.4167C19.658 11.4167 22.4747 13.1917 23.8497 16C22.4747 18.8083 19.6663 20.5833 16.4997 20.5833C13.333 20.5833 10.5247 18.8083 9.14967 16C10.5247 13.1917 13.3413 11.4167 16.4997 11.4167ZM16.4997 9.75C12.333 9.75 8.77467 12.3417 7.33301 16C8.77467 19.6583 12.333 22.25 16.4997 22.25C20.6663 22.25 24.2247 19.6583 25.6663 16C24.2247 12.3417 20.6663 9.75 16.4997 9.75ZM16.4997 13.9167C17.6497 13.9167 18.583 14.85 18.583 16C18.583 17.15 17.6497 18.0833 16.4997 18.0833C15.3497 18.0833 14.4163 17.15 14.4163 16C14.4163 14.85 15.3497 13.9167 16.4997 13.9167ZM16.4997 12.25C14.433 12.25 12.7497 13.9333 12.7497 16C12.7497 18.0667 14.433 19.75 16.4997 19.75C18.5663 19.75 20.2497 18.0667 20.2497 16C20.2497 13.9333 18.5663 12.25 16.4997 12.25Z"
                      fill="#20409B"
                    />
                    <rect
                      x="1.25"
                      y="0.75"
                      width="30.5"
                      height="30.5"
                      rx="7.25"
                      stroke="#20419B"
                      stroke-width="1.5"
                    />
                  </svg>
                  <svg
                    v-if="d.status > 1"
                    width="33"
                    height="32"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="cursor-pointer"
                    @click="openUrl({ fileName: d.operation.file_name_printing })"
                  >
                    <path
                      d="M22.3337 12.6667H21.5003V8.5H11.5003V12.6667H10.667C9.28366 12.6667 8.16699 13.7833 8.16699 15.1667V20.1667H11.5003V23.5H21.5003V20.1667H24.8337V15.1667C24.8337 13.7833 23.717 12.6667 22.3337 12.6667ZM13.167 10.1667H19.8337V12.6667H13.167V10.1667ZM19.8337 21.8333H13.167V18.5H19.8337V21.8333ZM21.5003 18.5V16.8333H11.5003V18.5H9.83366V15.1667C9.83366 14.7083 10.2087 14.3333 10.667 14.3333H22.3337C22.792 14.3333 23.167 14.7083 23.167 15.1667V18.5H21.5003Z"
                      fill="#20409B"
                    />
                    <path
                      d="M21.5003 16.4167C21.9606 16.4167 22.3337 16.0436 22.3337 15.5833C22.3337 15.1231 21.9606 14.75 21.5003 14.75C21.0401 14.75 20.667 15.1231 20.667 15.5833C20.667 16.0436 21.0401 16.4167 21.5003 16.4167Z"
                      fill="#20409B"
                    />
                    <rect
                      x="1.25"
                      y="0.75"
                      width="30.5"
                      height="30.5"
                      rx="7.25"
                      stroke="#20419B"
                      stroke-width="1.5"
                    />
                  </svg>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td colspan="7" class="pt-4 cursor-pointer" @click="show_mdt = !show_mdt">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="mr-2"
                  :class="!show_mdt ? 'upsidedown' : ''"
                >
                  <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="#1D2939" />
                </svg>
                <span class="fs-16 fw-600 mb-0 txt-grey-900">
                  {{
                  $t("multidisciplinary_board.lbl_mdt_title")
                  }}
                </span>
              </td>
            </tr>
          </tbody>
          <tbody v-if="session" v-show="show_mdt">
            <tr
              v-for="d in mdtDiseases"
              :key="d.id"
              @click="goToMdtDisease(d.id)"
              class="cursor-pointer"
            >
              <td @click.stop>
                <input v-if="d.sendable" type="checkbox" v-model="d.selectedToSend" />
              </td>
              <td :data-label="$t('multidisciplinary_board.lbl_patient')">
                <p class="fs-14 fw-600 txt-grey-900 mb-0">{{ d.patient_name }}</p>
                <p class="fs-12 txt-grey-600 mb-0">
                  ({{ getAges(d)
                  }}{{ d.patient_address ? " - " + d.patient_address : "" }})
                </p>
              </td>
              <td :data-label="$t('multidisciplinary_board.lbl_diagnose')">
                <p class="fs-14 fw-500 txt-grey-900 mb-0">
                  <!-- {{ d.patient_diagnostic }} -->
                  {{ patientDiagnostic(d) }}
                </p>
              </td>
              <td :data-label="$t('multidisciplinary_board.lbl_register_time')">
                <p class="fs-14 fw-500 txt-grey-700 mb-0">{{ formatDateDMYHm(d.created_at) }}</p>
              </td>
              <td :data-label="$t('multidisciplinary_board.lbl_treatment_doctor')">
                <p
                  class="fs-14 w-40 whitespace-nowrap fw-500 txt-grey-700 mb-0"
                >{{ d.doctor && d.doctor.name }}</p>
              </td>
              <td
                :data-label="$t('multidisciplinary_board.lbl_hd_status')"
                :set="
                (sttClass = mdtUtils.getStatusDisease(
                  d.sended ? 3 : d.status
                ))
              "
              >
                <p class="fs-16 fw-500 mb-0" :class="sttClass.class">{{ sttClass.text }}</p>
              </td>
              <td @click.stop :data-label="$t('multidisciplinary_board.lbl_mdt_report')">
                <div class="d-flex" v-if="d.concluding">
                  <el-dropdown v-if="d.concluding.multilang">
                    <div>
                      <svg
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="mr-2 cursor-pointer"
                      >
                        <path
                          d="M16.4997 11.4167C19.658 11.4167 22.4747 13.1917 23.8497 16C22.4747 18.8083 19.6663 20.5833 16.4997 20.5833C13.333 20.5833 10.5247 18.8083 9.14967 16C10.5247 13.1917 13.3413 11.4167 16.4997 11.4167ZM16.4997 9.75C12.333 9.75 8.77467 12.3417 7.33301 16C8.77467 19.6583 12.333 22.25 16.4997 22.25C20.6663 22.25 24.2247 19.6583 25.6663 16C24.2247 12.3417 20.6663 9.75 16.4997 9.75ZM16.4997 13.9167C17.6497 13.9167 18.583 14.85 18.583 16C18.583 17.15 17.6497 18.0833 16.4997 18.0833C15.3497 18.0833 14.4163 17.15 14.4163 16C14.4163 14.85 15.3497 13.9167 16.4997 13.9167ZM16.4997 12.25C14.433 12.25 12.7497 13.9333 12.7497 16C12.7497 18.0667 14.433 19.75 16.4997 19.75C18.5663 19.75 20.2497 18.0667 20.2497 16C20.2497 13.9333 18.5663 12.25 16.4997 12.25Z"
                          fill="#20409B"
                        />
                        <rect
                          x="1.25"
                          y="0.75"
                          width="30.5"
                          height="30.5"
                          rx="7.25"
                          stroke="#20419B"
                          stroke-width="1.5"
                        />
                      </svg>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item, index) in d.concluding.multilang"
                        :key="index"
                        :disabled="
                        !item.file_name_printing
                      "
                      >
                        <div
                          @click="openUrl({ fileName: item.file_name_printing })"
                        >{{ $t(`common.${appUtils.getLangCode(Number(item.lang))}`) }}</div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <el-dropdown v-if="d.concluding.multilang && (d.status > 1)">
                    <div>
                      <svg
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="cursor-pointer"
                      >
                        <path
                          d="M22.3337 12.6667H21.5003V8.5H11.5003V12.6667H10.667C9.28366 12.6667 8.16699 13.7833 8.16699 15.1667V20.1667H11.5003V23.5H21.5003V20.1667H24.8337V15.1667C24.8337 13.7833 23.717 12.6667 22.3337 12.6667ZM13.167 10.1667H19.8337V12.6667H13.167V10.1667ZM19.8337 21.8333H13.167V18.5H19.8337V21.8333ZM21.5003 18.5V16.8333H11.5003V18.5H9.83366V15.1667C9.83366 14.7083 10.2087 14.3333 10.667 14.3333H22.3337C22.792 14.3333 23.167 14.7083 23.167 15.1667V18.5H21.5003Z"
                          fill="#20409B"
                        />
                        <path
                          d="M21.5003 16.4167C21.9606 16.4167 22.3337 16.0436 22.3337 15.5833C22.3337 15.1231 21.9606 14.75 21.5003 14.75C21.0401 14.75 20.667 15.1231 20.667 15.5833C20.667 16.0436 21.0401 16.4167 21.5003 16.4167Z"
                          fill="#20409B"
                        />
                        <rect
                          x="1.25"
                          y="0.75"
                          width="30.5"
                          height="30.5"
                          rx="7.25"
                          stroke="#20419B"
                          stroke-width="1.5"
                        />
                      </svg>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item, index) in d.concluding.multilang"
                        :key="index"
                        :disabled="
                        !item.file_name_printing
                      "
                      >
                        <div
                          @click="openUrl({ fileName: item.file_name_printing })"
                        >{{ $t(`common.${appUtils.getLangCode(Number(item.lang))}`) }}</div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </td>
              <td :data-label="$t('multidisciplinary_board.lbl_surgery_report')">
                <div
                  @click.stop
                  class="d-flex"
                  v-if="d.operation && d.operation.file_name_printing"
                >
                  <svg
                    width="33"
                    height="32"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="mr-2 cursor-pointer"
                    @click="openUrl({ fileName: d.operation.file_name_printing })"
                  >
                    <path
                      d="M16.4997 11.4167C19.658 11.4167 22.4747 13.1917 23.8497 16C22.4747 18.8083 19.6663 20.5833 16.4997 20.5833C13.333 20.5833 10.5247 18.8083 9.14967 16C10.5247 13.1917 13.3413 11.4167 16.4997 11.4167ZM16.4997 9.75C12.333 9.75 8.77467 12.3417 7.33301 16C8.77467 19.6583 12.333 22.25 16.4997 22.25C20.6663 22.25 24.2247 19.6583 25.6663 16C24.2247 12.3417 20.6663 9.75 16.4997 9.75ZM16.4997 13.9167C17.6497 13.9167 18.583 14.85 18.583 16C18.583 17.15 17.6497 18.0833 16.4997 18.0833C15.3497 18.0833 14.4163 17.15 14.4163 16C14.4163 14.85 15.3497 13.9167 16.4997 13.9167ZM16.4997 12.25C14.433 12.25 12.7497 13.9333 12.7497 16C12.7497 18.0667 14.433 19.75 16.4997 19.75C18.5663 19.75 20.2497 18.0667 20.2497 16C20.2497 13.9333 18.5663 12.25 16.4997 12.25Z"
                      fill="#20409B"
                    />
                    <rect
                      x="1.25"
                      y="0.75"
                      width="30.5"
                      height="30.5"
                      rx="7.25"
                      stroke="#20419B"
                      stroke-width="1.5"
                    />
                  </svg>
                  <svg
                    width="33"
                    height="32"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="cursor-pointer"
                    @click="openUrl({ fileName: d.operation.file_name_printing })"
                  >
                    <path
                      d="M22.3337 12.6667H21.5003V8.5H11.5003V12.6667H10.667C9.28366 12.6667 8.16699 13.7833 8.16699 15.1667V20.1667H11.5003V23.5H21.5003V20.1667H24.8337V15.1667C24.8337 13.7833 23.717 12.6667 22.3337 12.6667ZM13.167 10.1667H19.8337V12.6667H13.167V10.1667ZM19.8337 21.8333H13.167V18.5H19.8337V21.8333ZM21.5003 18.5V16.8333H11.5003V18.5H9.83366V15.1667C9.83366 14.7083 10.2087 14.3333 10.667 14.3333H22.3337C22.792 14.3333 23.167 14.7083 23.167 15.1667V18.5H21.5003Z"
                      fill="#20409B"
                    />
                    <path
                      d="M21.5003 16.4167C21.9606 16.4167 22.3337 16.0436 22.3337 15.5833C22.3337 15.1231 21.9606 14.75 21.5003 14.75C21.0401 14.75 20.667 15.1231 20.667 15.5833C20.667 16.0436 21.0401 16.4167 21.5003 16.4167Z"
                      fill="#20409B"
                    />
                    <rect
                      x="1.25"
                      y="0.75"
                      width="30.5"
                      height="30.5"
                      rx="7.25"
                      stroke="#20419B"
                      stroke-width="1.5"
                    />
                  </svg>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <ModalSendCaseToOrg
      ref="ModalSendCaseToOrg"
      :mdtDiseaseIds="selectedMdtDiseaseIds"
      @sent="showSession"
    />
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
import mdtUtils from '../../utils/mdtUtils'
import Pptxgen from 'pptxgenjs'
import ModalSendCaseToOrg from './components/ModalSendCaseToOrg.vue'
import _ from 'lodash'
import moment from 'moment'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'SessionDetail',
  components: { ModalSendCaseToOrg },
  data () {
    return {
      room: null,
      session: null,
      search: '',
      mdtUtils,
      appUtils,
      url_pdf: '',
      show_ts: true,
      show_mdt: true,
      Pptxgen,
      gening: false,
      ppt_file: null,
      selectedMdtDiseaseIds: [],
      dtr_member: {},
      doctor_id: null,
      master: null,
      ws: null,
      whisper_room: null,
      isShowPrintModal: false,
      listSelected: [],
      isLoading: false
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.showSession()
    }
    this.doctor_id = appUtils.getLocalUser()?.doctor?.id
  },
  computed: {
    ...mapState({
      mdtRoomStore: state => state.mdtStore.mdtRoomDetail || {}
    }),
    langId () {
      return appUtils.getLangId(this.$lang || 'vi')
    },
    mdtRoomDiseases () {
      return _.map(this.session?.mdt_room_diseases, item => {
        const sent = item.public_mdt_case.find(
          c =>
            moment(c.mdt_date + ' 23:59:59', 'YYYY-MM-DD HH:mm:ss') >= moment()
        )
        const isOwner = this.doctor_id === item.doctor_id
        const isMaster =
          this.dtr_member?.role === 4 || this.dtr_member?.role === 1
        return {
          ...item,
          sendable:
            item.concluding &&
            item.status === 2 &&
            !sent &&
            (isOwner || isMaster),
          sended: !!sent
        }
      })
    },
    filteredAndSorted () {
      // function to compare names
      function compare (a, b) {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      }
      let search_string = appUtils.removeVietnameseTones(
        this.search.toLowerCase()
      )
      if (this.session && this.mdtRoomDiseases) {
        const result = this.mdtRoomDiseases
          .filter(d => {
            return (
              appUtils
                .removeVietnameseTones(d.patient_name.toLowerCase())
                .includes(search_string) ||
              (d?.doctor?.name &&
                appUtils
                  .removeVietnameseTones(d?.doctor?.name.toLowerCase())
                  .includes(search_string))
            )
          })
          .sort(compare)
        return result
      } else {
        return null
      }
    },
    mdtDiseases () {
      let data = this.filteredAndSorted
      if (data) {
        return data.filter(d => !d.type)
      } else {
        return []
      }
    },
    tsDiseases () {
      let data = this.filteredAndSorted
      if (data) {
        return data.filter(d => !!d.type)
      } else {
        return []
      }
    },
    approvedCase () {
      return this.session?.mdt_room_diseases?.filter(d => d.status === 2)
    },
    notApprovedCase () {
      return this.session?.mdt_room_diseases?.filter(d => d.status !== 2)
    },
    approvedCaseHC () {
      const result = _.filter(this.session?.mdt_room_diseases, { type: 0 })
      return result?.filter(d => d.status === 2)
    },
    notApprovedCaseHC () {
      const result = _.filter(this.session?.mdt_room_diseases, { type: 0 })
      return result?.filter(d => d.status !== 2)
    },
    approvedCaseTQM () {
      const result = _.filter(this.session?.mdt_room_diseases, { type: 1 })
      return result?.filter(d => d.status === 2)
    },
    notApprovedCaseTQM () {
      const result = _.filter(this.session?.mdt_room_diseases, { type: 1 })
      return result?.filter(d => d.status !== 2)
    },
    checkinMemberString () {
      if (!this.session?.mdt_checkins.length) return
      let string = this.session?.mdt_checkins?.map(d => d.doctor?.name)
      return string.join(', ')
    }
  },
  watch: {
    // $echo (e) {
    //   if (e && this.whisper_room) {
    //     this.socketConnectMdtDiseases()
    //   }
    // }
  },
  methods: {
    ...mapMutations('clinicDoctorStore', ['setListDiseasePrint']),
    // socketConnectMdtDiseases () {
    //   const self = this

    //   if (!self.$conectedEcho || !self.room) return

    //   const { room } = self.room
    //   self.whisper_room = self.$echo.private('twl_room.' + room.room_name)

    //   self.whisper_room.listen('RoomMessageWasReceived', function (_data) {
    //     console.log(_data)
    //     const { message } = _data
    //     const { type } = JSON.parse(message)
    //     if (type === 'refreshMdtDiseases') {
    //       self.showSession()
    //     }
    //   })
    // },
    patientDiagnostic (item) {
      if (item?.multilang?.length) {
        const langId = this.langId
        const r = item?.multilang.find(item => item.lang === langId)
        if (!r) return item?.patient_diagnostic
        else return r.patient_diagnostic
      }
      return item?.patient_diagnostic
    },
    showModalSend () {
      this.selectedMdtDiseaseIds = _.filter(
        this.mdtRoomDiseases,
        'selectedToSend'
      ).map(e => e.id)

      this.$refs.ModalSendCaseToOrg.openModal()
      // window.$('#modalSendCaseToOrg').modal('show')
    },
    async showSession () {
      let self = this
      try {
        this.isLoading = true
        await this.$rf
          .getRequest('DoctorRequest')
          .showMdtSession(this.$route.params.id)
          .then(async r => {
            self.session = r.data
            await self.showMdtRoom(r.data.mdt_room_id)
            // self.processPPT(r.data.mdt_room_diseases)
          })
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async showMdtRoom (id) {
      let self = this
      if (self.mdtRoomStore?.id === Number(id)) {
        const clonedMdtRoom = { ...self.mdtRoomStore }

        self.room = clonedMdtRoom
        self.ws = clonedMdtRoom?.clinic?.name.toUpperCase()
        self.dtr_member = clonedMdtRoom?.role || {}

        return clonedMdtRoom
      } else {
        await self.$rf
          .getRequest('DoctorRequest')
          .getMDTRoomDetail(id)
          .then(r => {
            self.room = r.data
            self.ws = r.data?.clinic?.name.toUpperCase()
            self.dtr_member = r?.data?.role || {}
            this.$store.commit('mdtStore/setMdtRoomDetail', r.data)
          })
      }
    },
    formatDate (date) {
      return window.moment(date).format('DD/MM/YYYY')
    },
    formatDateDMYHm (dt) {
      return window.moment(dt).format('DD/MM/YYYY HH:mm')
    },
    backToMdtDetail () {
      this.$router.push({ name: 'ListMdt', query: { mdtid: this.room?.id } })
    },
    async openUrl ({ fileName, print = false }) {
      if (!fileName) {
        this.$toast.open({
          message: this.$t('multidisciplinary_board.lbl_notfound'),
          type: 'error'
        })
        return
      }

      try {
        window.open(fileName)
        // const res = await this.$rf.getRequest('DoctorRequest').getEmrDocument({
        //   fileName
        // })
        // if (res.data) {
        //   // var encodedUrl = encodeURIComponent(res.data?.documentLink)
        //   // var iFrameUrl = `https://docs.google.com/viewerng/viewer?url=${encodedUrl}`

        //   if (print) {
        //     const printWindow = window.open(res.data?.documentLink)
        //     printWindow.print()

        //     printWindow.onafterprint = function () {
        //       printWindow.close()
        //     }
        //   } else {
        //     window.open(res.data?.documentLink)
        //   }
        // }
      } catch (error) {
        console.log(error)
      }
    },
    open (url, e) {
      e.stopPropagation()
      window.open(url)
    },
    print (url, e) {
      e.stopPropagation()
      window.open(url)
    },
    createMdtDisease () {
      this.$router.push({
        name: 'CreateMdtDisease',
        params: { room_id: this.room?.id }
      })
    },
    goToRoom (r) {
      let dm = ''
      if (process.env.NODE_ENV === 'development') {
        dm = 'https://dev.meet.hodo.com.vn/#/'
      } else {
        dm = 'https://meet.hodo.com.vn/#/'
      }
      let token = appUtils.getLocalToken()
      let routeData = dm + '_mdt/' + r?.room?.room_name + '?token=' + token
      console.log({routeData})
      window.open(routeData, '_blank')
    },
    goToMdtDisease (id) {
      this.$router.push({ name: 'MdtDiseaseDetail', params: { id: id } })
    },
    // TQM
    processTQM () {
      let data = this.session?.mdt_room_diseases
      const result = _.filter(data, { type: 1 })
      if (result?.length) {
        let logo = this.getAvatar(this.room?.clinic)
        let logoOpts = { x: 0.5, y: 0.1, h: 0.6, w: 0.6 }
        let typeTextOpts = {
          x: 0.3,
          y: 0.1,
          h: 0.6,
          w: '100%',
          align: 'center',
          fontFace: 'Arial',
          fontSize: 22
        }
        let pres = new Pptxgen()
        let slide = pres.addSlide(this.room?.clinic?.name)
        slide.addText('THÔNG QUA MỔ', {
          x: 0,
          y: '15%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 40,
          w: '100%',
          h: '15%',
          bold: true
        })
        if (this.room?.clinic?.name.length > 27) {
          slide.addText(this.ws, {
            x: 0,
            y: '32%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 40,
            w: '100%',
            h: '15%',
            bold: true
          })
        } else {
          slide.addText(this.ws, {
            x: 0,
            y: '27%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 40,
            w: '100%',
            h: '15%',
            bold: true
          })
        }
        // slide.addText(ws.toUpperCase(), { x: 0, y: '32%', fontFace: 'Arial', align: 'center', color: 'ffffff', fontSize: 40, w: '100%', h: '15%', bold: true })
        slide.addText('Ngày: ' + this.formatDate(this.session?.date), {
          x: 0,
          y: '48%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 24,
          w: '100%',
          h: '15%'
        })
        slide.addText('Số ca TQM: ' + result?.length, {
          x: 0,
          y: '58%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 24,
          w: '100%',
          h: '15%'
        })
        slide.background = { color: '20419B' }

        result.forEach((d, i) => {
          // // 2. Add a Slide

          // // 3. Add one or more objects (Tables, Shapes, Images, Text and Media) to the Slide
          // let t1 = 'Ca ' + (i <= 9 ? '0' + i : i) + '     ' + 'MHS: ' + d.code
          // let tO1 = { x: 1, y: 1, color: '000000', fontFace: 'Arial', fontSize: 24 }
          // slide.addText(t1, tO1)
          // let textboxText = d.patient_name
          // let textboxOpts = { x: 1, y: 1.1, color: '000000', fontFace: 'Arial', fontSize: 24 }
          // slide.addText(textboxText, textboxOpts)

          // pres.tableToSlides('tableD' + i, { x: 0.3, y: 0.3 })

          // 4. Save the Presentation

          let sliden = pres.addSlide(d.patient_name)
          if (logo) {
            sliden.addImage({ path: logo, ...logoOpts })
          }
          sliden.addText('THÔNG QUA MỔ ' + ++i, typeTextOpts)
          let rows = [
            [
              {
                text: 'Họ và tên BN:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: d.patient_name,
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 2,
                  bold: true
                }
              },
              {
                text: 'Tuổi: ' + mdtUtils.getAges(new Date(d.patient_birthday)),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: 'Giới tính: ' + mdtUtils.getGender(d.patient_gender),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              }
            ],
            [
              {
                text: 'Ngày vào viện:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: d.admission_date
                  ? window.moment(d.admission_date).format('DD/MM/YYYY')
                  : '',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ],
            [
              {
                text: 'Chẩn đoán:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text:
                  d.operation?.diagnostic ||
                  (d.multilang.length && d.multilang[0]?.patient_diagnostic) ||
                  d.patient_diagnostic ||
                  '',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ],
            [
              {
                text: 'Tóm tắt bệnh án:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: d.operation?.medical_history
                  ? this.stringToHTML(d.operation?.medical_history)
                  : d.multilang.length
                    ? this.stringToHTML(
                      d.multilang[0]?.patient_diseases_current_cure
                    )
                    : d.patient_diseases_current_cure
                      ? this.stringToHTML(d.patient_diseases_current_cure)
                      : '',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ],
            // [
            //   { text: 'Chỉ định:', options: { align: 'left', fontFace: 'Arial', fontSize: 14, bold: true } },
            //   { text: this.stringToHTML(d.indication), options: { align: 'left', fontFace: 'Arial', fontSize: 14, colspan: 4, bold: true } }
            // ],
            [
              {
                text: 'Kết luận:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: d.operation?.conclusion
                  ? this.stringToHTML(d.operation?.conclusion)
                  : d.multilang.length
                    ? this.stringToHTML(d.multilang[0]?.conclusion)
                    : d.conclusion
                      ? this.stringToHTML(d.conclusion)
                      : '',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ],
            [
              {
                text: 'Hướng điều trị:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text:
                  (d.multilang.length &&
                    this.stringToHTML(d.multilang[0]?.treatment)) ||
                  this.stringToHTML(d.treatment),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ]
          ]

          if (d.operation?.anaesthetic_method) {
            rows.push([
              {
                text: 'Phương pháp vô cảm:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: d.operation?.anaesthetic_method || '',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ])
          }

          if (d.operation?.surgical_team) {
            rows.push([
              {
                text: 'Kíp mổ:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: d.operation?.surgical_team || '',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ])
          }

          if (d.operation?.anaesthetic_team) {
            rows.push([
              {
                text: 'Kíp gây mê:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: d.operation?.anaesthetic_team || '',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ])
          }

          sliden.addTable(rows, { x: 0.3, y: 0.7 })
          let img_count = 0
          let imgOpts = { y: '84%', h: '15%', w: '17%' }
          if (d.image_url_1) {
            img_count++
            sliden.addImage({
              path: d.image_url_1,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            })
          }
          if (d.image_url_2) {
            img_count++
            let img2 = {
              path: d.image_url_2,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            }
            sliden.addImage(img2)
          }
          if (d.image_url_3) {
            img_count++
            let img3 = {
              path: d.image_url_3,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            }
            sliden.addImage(img3)
          }
          if (d.image_url_4) {
            img_count++
            let img4 = {
              path: d.image_url_4,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            }
            sliden.addImage(img4)
          }
          if (d.image_url_5) {
            img_count++
            let img5 = {
              path: d.image_url_5,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            }
            sliden.addImage(img5)
          }
        })
        let slideEnd = pres.addSlide('Thanks!')
        slideEnd.addText('THÔNG QUA MỔ', {
          x: 0,
          y: '5%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 36,
          w: '100%',
          h: '15%',
          bold: true
        })
        if (this.room?.clinic?.name.length > 28) {
          slideEnd.addText(this.ws, {
            x: 0,
            y: '21%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 36,
            w: '100%',
            h: '15%',
            bold: true
          })
        } else {
          slideEnd.addText(this.ws, {
            x: 0,
            y: '16%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 36,
            w: '100%',
            h: '15%',
            bold: true
          })
        }
        slideEnd.addText('Ngày: ' + this.formatDate(this.session?.date), {
          x: 0,
          y: '36%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 20,
          w: '100%',
          h: '15%'
        })
        slideEnd.addText(
          'Thành phần tham gia: ' + (this.checkinMemberString || ''),
          {
            x: 0,
            y: '38%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 20,
            w: '100%',
            h: '30%'
          }
        )
        slideEnd.addText('Chủ tọa: ' + (this.room?.doctor?.name || ''), {
          x: 0,
          y: '57%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 20,
          w: '100%',
          h: '15%'
        })
        slideEnd.addText(
          'Số lượng ca đã duyệt: ' + (this.approvedCaseTQM?.length || 0),
          {
            x: 0,
            y: '67%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 20,
            w: '100%',
            h: '15%'
          }
        )
        slideEnd.addText(
          'Số lượng ca chưa duyệt: ' + (this.notApprovedCaseTQM?.length || 0),
          {
            x: 0,
            y: '77%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 20,
            w: '100%',
            h: '15%'
          }
        )

        // slideEnd.addText('Số ca bệnh:' + data?.length, { x: 0, y: '58%', align: 'center', color: 'ffffff', fontSize: 24, w: '100%' })
        slideEnd.background = { color: '20419B' }
        pres.writeFile({
          fileName: `Presentation_TQM_${window
            .moment(this.session?.date)
            .format('DD-MM-YYYY')}.pptx`
        })
      } else {
        this.$message({
          type: 'warning',
          message: 'Không có thông tin TQM để xuất file'
        })
      }
    },
    // HC
    processHC () {
      let data = this.session?.mdt_room_diseases
      const result = _.filter(data, { type: 0 })
      if (result?.length) {
        let logo = this.getAvatar(this.room?.clinic)
        let logoOpts = { x: 0.5, y: 0.1, h: 0.6, w: 0.6 }
        let typeTextOpts = {
          x: 0.3,
          y: 0.1,
          h: 0.6,
          w: '100%',
          align: 'center',
          fontFace: 'Arial',
          fontSize: 22
        }
        let pres = new Pptxgen()
        let slide = pres.addSlide(this.room?.clinic?.name)
        slide.addText('HỘI CHẨN', {
          x: 0,
          y: '15%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 40,
          w: '100%',
          h: '15%',
          bold: true
        })
        if (this.room?.clinic?.name.length > 27) {
          slide.addText(this.ws, {
            x: 0,
            y: '32%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 40,
            w: '100%',
            h: '15%',
            bold: true
          })
        } else {
          slide.addText(this.ws, {
            x: 0,
            y: '27%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 40,
            w: '100%',
            h: '15%',
            bold: true
          })
        }
        slide.addText('Ngày: ' + this.formatDate(this.session?.date), {
          x: 0,
          y: '48%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 24,
          w: '100%',
          h: '15%'
        })
        slide.addText('Số ca HC: ' + result?.length, {
          x: 0,
          y: '58%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 24,
          w: '100%',
          h: '15%'
        })
        slide.background = { color: '20419B' }

        result.forEach((d, i) => {
          // // 2. Add a Slide

          // // 3. Add one or more objects (Tables, Shapes, Images, Text and Media) to the Slide
          // let t1 = 'Ca ' + (i <= 9 ? '0' + i : i) + '     ' + 'MHS: ' + d.code
          // let tO1 = { x: 1, y: 1, color: '000000', fontFace: 'Arial', fontSize: 24 }
          // slide.addText(t1, tO1)
          // let textboxText = d.patient_name
          // let textboxOpts = { x: 1, y: 1.1, color: '000000', fontFace: 'Arial', fontSize: 24 }
          // slide.addText(textboxText, textboxOpts)

          // pres.tableToSlides('tableD' + i, { x: 0.3, y: 0.3 })

          // 4. Save the Presentation

          let sliden = pres.addSlide(d.patient_name)
          if (logo) {
            sliden.addImage({ path: logo, ...logoOpts })
          }
          sliden.addText('HỘI CHẨN ' + ++i, typeTextOpts)
          let rows = [
            [
              {
                text: 'Họ và tên BN:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: d.patient_name,
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 2,
                  bold: true
                }
              },
              {
                text: 'Tuổi: ' + mdtUtils.getAges(d.patient_birthday),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: 'Giới tính: ' + mdtUtils.getGender(d.patient_gender),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              }
            ],
            [
              {
                text: 'Ngày vào viện:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: d.admission_date
                  ? window.moment(d.admission_date).format('DD/MM/YYYY')
                  : '',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ],
            [
              {
                text: 'Chẩn đoán:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text:
                  (d.multilang.length && d.multilang[0]?.patient_diagnostic) ||
                  d.patient_diagnostic ||
                  '',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ],
            [
              {
                text: 'Tóm tắt bệnh án:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text:
                  this.stringToHTML(
                    d.concluding?.multilang[0]?.treatment_progress
                  ) ||
                  (d.multilang.length &&
                    this.stringToHTML(
                      d.multilang[0]?.patient_diseases_current_cure
                    )) ||
                  this.stringToHTML(d.patient_diseases_current_cure),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ],
            // [
            //   { text: 'Chỉ định:', options: { align: 'left', fontFace: 'Arial', fontSize: 14, bold: true } },
            //   { text: this.stringToHTML(d.indication), options: { align: 'left', fontFace: 'Arial', fontSize: 14, colspan: 4, bold: true } }
            // ],
            [
              {
                text: 'Kết luận:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text:
                  this.stringToHTML(d.concluding?.multilang[0]?.conclusion) ||
                  (d.multilang.length &&
                    this.stringToHTML(d.multilang[0]?.conclusion)) ||
                  this.stringToHTML(d.conclusion),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ],
            [
              {
                text: 'Hướng điều trị:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text:
                  this.stringToHTML(d.concluding?.multilang[0]?.treatment) ||
                  (d.multilang.length &&
                    this.stringToHTML(d.multilang[0]?.treatment)) ||
                  this.stringToHTML(d.treatment),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ]
          ]
          sliden.addTable(rows, { x: 0.3, y: 0.7 })
          let img_count = 0
          let imgOpts = { y: '84%', h: '15%', w: '17%' }
          if (d.image_url_1) {
            img_count++
            sliden.addImage({
              path: d.image_url_1,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            })
          }
          if (d.image_url_2) {
            img_count++
            let img2 = {
              path: d.image_url_2,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            }
            sliden.addImage(img2)
          }
          if (d.image_url_3) {
            img_count++
            let img3 = {
              path: d.image_url_3,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            }
            sliden.addImage(img3)
          }
          if (d.image_url_4) {
            img_count++
            let img4 = {
              path: d.image_url_4,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            }
            sliden.addImage(img4)
          }
          if (d.image_url_5) {
            img_count++
            let img5 = {
              path: d.image_url_5,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            }
            sliden.addImage(img5)
          }
        })
        let slideEnd = pres.addSlide('Thanks!')
        slideEnd.addText('HỘI CHẨN ', {
          x: 0,
          y: '5%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 36,
          w: '100%',
          h: '15%',
          bold: true
        })
        if (this.ws.length > 28) {
          slideEnd.addText(this.ws, {
            x: 0,
            y: '21%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 36,
            w: '100%',
            h: '15%',
            bold: true
          })
        } else {
          slideEnd.addText(this.ws, {
            x: 0,
            y: '16%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 36,
            w: '100%',
            h: '15%',
            bold: true
          })
        }
        slideEnd.addText('Ngày: ' + this.formatDate(this.session?.date), {
          x: 0,
          y: '36%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 24,
          w: '100%',
          h: '15%'
        })
        slideEnd.addText(
          'Thành phần tham gia: ' + (this.checkinMemberString || ''),
          {
            x: 0,
            y: '38%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 24,
            w: '100%',
            h: '30%'
          }
        )
        slideEnd.addText('Chủ tọa: ' + (this.room?.doctor?.name || ''), {
          x: 0,
          y: '57%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 24,
          w: '100%',
          h: '15%'
        })
        slideEnd.addText(
          'Số lượng ca đã duyệt: ' + (this.approvedCaseHC?.length || 0),
          {
            x: 0,
            y: '67%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 24,
            w: '100%',
            h: '15%'
          }
        )
        slideEnd.addText(
          'Số lượng ca chưa duyệt: ' + (this.notApprovedCaseHC?.length || 0),
          {
            x: 0,
            y: '77%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 24,
            w: '100%',
            h: '15%'
          }
        )

        // slideEnd.addText('Số ca bệnh:' + data?.length, { x: 0, y: '58%', align: 'center', color: 'ffffff', fontSize: 24, w: '100%' })
        slideEnd.background = { color: '20419B' }
        pres.writeFile({
          fileName: `Presentation_HC_${window
            .moment(this.session?.date)
            .format('DD-MM-YYYY')}.pptx`
        })
      } else {
        this.$message({
          type: 'warning',
          message: 'Không có thông tin HC để xuất file'
        })
      }
    },
    //
    processPPT () {
      let data = this.session?.mdt_room_diseases
      if (data?.length) {
        let logo = this.getAvatar(this.room?.clinic)
        let logoOpts = { x: 0.5, y: 0.1, h: 0.6, w: 0.6 }
        let typeTextOpts = {
          x: 0.3,
          y: 0.1,
          h: 0.6,
          w: '100%',
          align: 'center',
          fontFace: 'Arial',
          fontSize: 22
        }
        let pres = new Pptxgen()
        let slide = pres.addSlide(this.room?.clinic?.name)
        slide.addText(this.room?.clinic?.name, {
          x: 0,
          y: '24%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 50,
          w: '100%',
          h: '15%',
          bold: true
        })
        slide.addText('Ngày: ' + this.formatDate(this.session?.date), {
          x: 0,
          y: '42%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 24,
          w: '100%',
          h: '15%'
        })
        slide.addText('Số ca bệnh: ' + data?.length, {
          x: 0,
          y: '52%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 24,
          w: '100%',
          h: '15%'
        })
        slide.background = { color: '20419B' }
        data.forEach((d, i) => {
          // // 2. Add a Slide

          // // 3. Add one or more objects (Tables, Shapes, Images, Text and Media) to the Slide
          // let t1 = 'Ca ' + (i <= 9 ? '0' + i : i) + '     ' + 'MHS: ' + d.code
          // let tO1 = { x: 1, y: 1, color: '000000', fontFace: 'Arial', fontSize: 24 }
          // slide.addText(t1, tO1)
          // let textboxText = d.patient_name
          // let textboxOpts = { x: 1, y: 1.1, color: '000000', fontFace: 'Arial', fontSize: 24 }
          // slide.addText(textboxText, textboxOpts)

          // pres.tableToSlides('tableD' + i, { x: 0.3, y: 0.3 })

          // 4. Save the Presentation

          let sliden = pres.addSlide(d.patient_name)
          if (logo) {
            sliden.addImage({ path: logo, ...logoOpts })
          }
          sliden.addText(d.type ? 'THÔNG QUA MỔ' : 'HỘI CHẨN', typeTextOpts)
          let rows = [
            [
              {
                text: 'Họ và tên BN:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: d.patient_name,
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 2,
                  bold: true
                }
              },
              {
                text: 'Tuổi: ' + mdtUtils.getAges(new Date(d.patient_birthday)),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: 'Giới tính: ' + mdtUtils.getGender(d.patient_gender),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              }
            ],
            [
              {
                text: 'Ngày vào viện:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text: d.admission_date
                  ? window.moment(d.admission_date).format('DD/MM/YYYY')
                  : '',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ],
            [
              {
                text: 'Chẩn đoán:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text:
                  (d.type && d.operation?.diagnostic) ||
                  (d.multilang.length && d.multilang[0]?.patient_diagnostic) ||
                  d.patient_diagnostic,
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ],
            [
              {
                text: 'Tóm tắt bệnh án:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text:
                  (d.type
                    ? this.stringToHTML(d.operation?.medical_history)
                    : this.stringToHTML(
                        d.concluding?.multilang[0]?.treatment_progress
                    )) ||
                  (d.multilang.length &&
                    this.stringToHTML(
                      d.multilang[0]?.patient_diseases_current_cure
                    )) ||
                  this.stringToHTML(d.patient_diseases_current_cure),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ],
            // [
            //   { text: 'Chỉ định:', options: { align: 'left', fontFace: 'Arial', fontSize: 14, bold: true } },
            //   { text: this.stringToHTML(d.indication), options: { align: 'left', fontFace: 'Arial', fontSize: 14, colspan: 4, bold: true } }
            // ],
            [
              {
                text: 'Kết luận:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text:
                  (d.type
                    ? this.stringToHTML(d.operation?.conclusion)
                    : this.stringToHTML(
                        d.concluding?.multilang[0]?.conclusion
                    )) ||
                  (d.multilang.length &&
                    this.stringToHTML(d.multilang[0]?.conclusion)) ||
                  this.stringToHTML(d.conclusion),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ],
            [
              {
                text: 'Hướng điều trị:',
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  bold: true
                }
              },
              {
                text:
                  (d.type
                    ? this.stringToHTML(d.treatment)
                    : this.stringToHTML(
                        d.concluding?.multilang[0]?.treatment
                    )) ||
                  (d.multilang.length &&
                    this.stringToHTML(d.multilang[0]?.treatment)) ||
                  this.stringToHTML(d.treatment),
                options: {
                  align: 'left',
                  fontFace: 'Arial',
                  fontSize: 14,
                  colspan: 4,
                  bold: true
                }
              }
            ]
          ]

          if (d.type) {
            if (d.operation?.anaesthetic_method) {
              rows.push([
                {
                  text: 'Phương pháp vô cảm:',
                  options: {
                    align: 'left',
                    fontFace: 'Arial',
                    fontSize: 14,
                    bold: true
                  }
                },
                {
                  text: d.operation?.anaesthetic_method || '',
                  options: {
                    align: 'left',
                    fontFace: 'Arial',
                    fontSize: 14,
                    colspan: 4,
                    bold: true
                  }
                }
              ])
            }

            if (d.operation?.surgical_team) {
              rows.push([
                {
                  text: 'Kíp mổ:',
                  options: {
                    align: 'left',
                    fontFace: 'Arial',
                    fontSize: 14,
                    bold: true
                  }
                },
                {
                  text: d.operation?.surgical_team || '',
                  options: {
                    align: 'left',
                    fontFace: 'Arial',
                    fontSize: 14,
                    colspan: 4,
                    bold: true
                  }
                }
              ])
            }

            if (d.operation?.anaesthetic_team) {
              rows.push([
                {
                  text: 'Kíp gây mê:',
                  options: {
                    align: 'left',
                    fontFace: 'Arial',
                    fontSize: 14,
                    bold: true
                  }
                },
                {
                  text: d.operation?.anaesthetic_team || '',
                  options: {
                    align: 'left',
                    fontFace: 'Arial',
                    fontSize: 14,
                    colspan: 4,
                    bold: true
                  }
                }
              ])
            }
          }

          sliden.addTable(rows, { x: 0.3, y: 0.7 })
          let img_count = 0
          let imgOpts = { y: '85%', h: '15%', w: '17%' }
          if (d.image_url_1) {
            img_count++
            sliden.addImage({
              path: d.image_url_1,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            })
          }
          if (d.image_url_2) {
            img_count++
            let img2 = {
              path: d.image_url_2,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            }
            sliden.addImage(img2)
          }
          if (d.image_url_3) {
            img_count++
            let img3 = {
              path: d.image_url_3,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            }
            sliden.addImage(img3)
          }
          if (d.image_url_4) {
            img_count++
            let img4 = {
              path: d.image_url_4,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            }
            sliden.addImage(img4)
          }
          if (d.image_url_5) {
            img_count++
            let img5 = {
              path: d.image_url_5,
              ...imgOpts,
              x: img_count > 1 ? (img_count - 1) * 19 + 2 + '%' : 0.5
            }
            sliden.addImage(img5)
          }
        })
        let slideEnd = pres.addSlide('Thanks!')
        slideEnd.addText('HỘI CHẨN ', {
          x: 0,
          y: '5%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 36,
          w: '100%',
          h: '15%',
          bold: true
        })
        if (this.room?.clinic?.name.length > 28) {
          slideEnd.addText(this.ws, {
            x: 0,
            y: '21%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 36,
            w: '100%',
            h: '15%',
            bold: true
          })
        } else {
          slideEnd.addText(this.ws, {
            x: 0,
            y: '16%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 36,
            w: '100%',
            h: '15%',
            bold: true
          })
        }
        slideEnd.addText('Ngày: ' + this.formatDate(this.session?.date), {
          x: 0,
          y: '36%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 24,
          w: '100%',
          h: '15%'
        })
        slideEnd.addText(
          'Thành phần tham gia: ' + (this.checkinMemberString || ''),
          {
            x: 0,
            y: '38%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 24,
            w: '100%',
            h: '30%'
          }
        )
        slideEnd.addText('Chủ tọa: ' + (this.room?.doctor?.name || ''), {
          x: 0,
          y: '57%',
          fontFace: 'Arial',
          align: 'center',
          color: 'ffffff',
          fontSize: 24,
          w: '100%',
          h: '15%'
        })
        slideEnd.addText(
          'Số lượng ca đã duyệt: ' + (this.approvedCase?.length || 0),
          {
            x: 0,
            y: '67%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 24,
            w: '100%',
            h: '15%'
          }
        )
        slideEnd.addText(
          'Số lượng ca chưa duyệt: ' + (this.notApprovedCase?.length || 0),
          {
            x: 0,
            y: '77%',
            fontFace: 'Arial',
            align: 'center',
            color: 'ffffff',
            fontSize: 24,
            w: '100%',
            h: '15%'
          }
        )

        // slideEnd.addText('Số ca bệnh:' + data?.length, { x: 0, y: '58%', align: 'center', color: 'ffffff', fontSize: 24, w: '100%' })
        slideEnd.background = { color: '20419B' }
        pres.writeFile({
          fileName: `Presentation_HC_TQM_${window
            .moment(this.session?.date)
            .format('DD-MM-YYYY')}.pptx`
        })
      } else {
        this.$message({
          type: 'warning',
          message: 'Không có thông tin HC và TQM để xuất file'
        })
      }
    },
    stringToHTML (str) {
      if (!str) return ''
      var pattern = '</p>',
        re = new RegExp(pattern, 'g')
      let newstr = str.replace(re, '\n')
      newstr = newstr.replace(/<[^>]+>/g, '')
      newstr = this.decodeEntities(newstr).trim()
      return this.decodeEntities(newstr)
    },
    decodeEntities (encodedString) {
      var translate_re = /&(nbsp|amp|quot|lt|gt);/g
      var translate = {
        nbsp: ' ',
        amp: '&',
        quot: '"',
        lt: '<',
        gt: '>',
        'apos;': "'"
      }
      return encodedString
        .replace(translate_re, function (match, entity) {
          return translate[entity]
        })
        .replace(/&#(\d+);/gi, function (match, numStr) {
          var num = parseInt(numStr, 10)
          return String.fromCharCode(num)
        })
    },
    getAvatar (clinic) {
      if (clinic && clinic.avatar) {
        return process.env.VUE_APP_BASE_IMAGE_URL + 'api/logo/' + clinic.avatar
      }
    },
    gotoPrint () {
      // this.listSelected = _.filter(this.mdtRoomDiseases, 'selectedToSend')
      const newMdtRoomDiseases = this.mdtRoomDiseases.filter(
        item => item.selectedToSend
      )

      if (newMdtRoomDiseases.length > 0) {
        this.listSelected = newMdtRoomDiseases
      } else {
        this.listSelected = this.mdtRoomDiseases.filter(
          item => item.status === 2
        )
      }
      this.setListDiseasePrint(this.listSelected)
      const mdtSessionId = this.$route.params.id
      this.$router.push({
        name: 'HoiChanCasePrinter',
        params: { id: mdtSessionId }
      })
    },
    getAges (data) {
      return data?.alias && data?.alias.status && data?.alias.alias_age
        ? this.mdtUtils.getAges(data?.alias.alias_age)
        : this.mdtUtils.getAges(new Date(data?.patient_birthday))
    }
  }
}
</script>

<style scoped>
.upsidedown {
  -webkit-transform: rotateX(180deg);
  transform: rotateX(180deg);
}

.py-0 {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}

.fs-14 {
  font-size: 14px !important;
}

.fs-18 {
  font-size: 18px !important;
}

#xxx th {
  padding: 2px !important;
}

.fw-400 {
  font-weight: normal !important;
}

.xxx {
  opacity: 0.001;
}
</style>
